import React from "react";
import { Props } from "./types";

function DeactivateResourceIcon({ className }: Props) {
  return (
    <svg className={className} viewBox="0 0 14.4 16.46">
      <path
        id="Icon_awesome-user"
        data-name="Icon awesome-user"
        d="M7.2,8.23A4.115,4.115,0,1,0,3.086,4.115,4.114,4.114,0,0,0,7.2,8.23Zm2.88,1.029H9.543a5.594,5.594,0,0,1-4.686,0H4.32A4.321,4.321,0,0,0,0,13.579v1.337A1.543,1.543,0,0,0,1.543,16.46H12.857A1.543,1.543,0,0,0,14.4,14.917V13.579A4.321,4.321,0,0,0,10.08,9.259Z"
        fill="red"
      />
      <line x1="0" y1="16" x2="14.4" y2="0" stroke="black" strokeWidth="2" />
    </svg>
  );
}

export { DeactivateResourceIcon };
